import React from 'react'
import { pdf, Document, Text, Page, View, Image } from '@react-pdf/renderer'
import reportStyles from './PDFReportStyles'   

const FirstPage = (params) => {
  const entity = params.entity;
  const reportParams = params.params;  

  //Report Params
//  console.log(reportParams.agerange);
  let ageRangeDesc = '6 years and above';
  if (reportParams.agerange === '1') {
      ageRangeDesc = '2 years';
  } else if (reportParams.agerange === '2') {
      ageRangeDesc = '3 to 5 years';
  }
  let genderImage = process.env.PUBLIC_URL + '/images/ReportBoyMid.png';
  let fontColorApp = 'White';
  let styletitle = 'reportStyles.titleWhite';
  let styletitle1 = 'reportStyles.title1White';
  let styletitle2 = 'reportStyles.title2White';
  let styletitle3 = 'reportStyles.title3White';
  if (entity.gender === 'F') {
    genderImage = process.env.PUBLIC_URL + '/images/ReportGirlMid.png';
    fontColorApp = 'Black';
    styletitle = 'reportStyles.titleBlack';
    styletitle1 = 'reportStyles.title1Black';
    styletitle2 = 'reportStyles.title2Black';
    styletitle3 = 'reportStyles.title3Black';
  }  
  console.log(genderImage);


  return (
    <Page size="A4" style={reportStyles.FirstPage}>
      <View style={reportStyles.FirstPageHeaderContainer}>
          <Image src={genderImage}  style={reportStyles.image}/>                                                 
      </View>                            
      <View style={reportStyles.FirstPageMainContainer}>
          <Text style={reportStyles.title2}>WE CARE FOR YOUR CHILD'S WELLBEING</Text>                    
          <Text style={reportStyles.title}>CHILDRENDOC</Text>                    
          <Text style={reportStyles.title1}>3D Online Wellbeing Scan Report</Text>                    
          <Text style={reportStyles.title3}>Physical, Mental and Social Factors Screening</Text>                    
      </View>                            
      <View style={reportStyles.BottomContainer}>
          <Text style={reportStyles.subtitle}>Child Name: {entity.firstname} {entity.lastname}</Text>
          <Text style={reportStyles.subtitle}>Age Group: {ageRangeDesc}</Text>
          <Text style={reportStyles.subtitle}>Pediatrician Name: N/A</Text>
          {/* <Text style={reportStyles.footer}>This report is for information and education purposes only. Please consult a licensed Pediatrician for any medical advice.</Text> */}
      </View>                            
      <View style={reportStyles.FooterContainerSmall}>
        <Text style={reportStyles.footer}>This action plan is not a medical prescription. Your doctor will provide an additional prescription, if required.
        </Text>
      </View>                            
    </Page>         
  )        
}
  
export default FirstPage